import React, { useContext, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { AuthContext } from '../contexts/AuthContext'
import AuthLayout from '../layouts/AuthLayout'
import Bounce from 'react-activity/dist/Bounce'
import 'react-activity/dist/Bounce.css'
import { Eye, EyeOff } from 'lucide-react'

const Home = () => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const ifredirect = searchParams.get('redirect') !== null ? searchParams.get('redirect') : ''

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError] = useState('')

  const { login, isLoading } = useContext(AuthContext)

  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (isLoading === false) {
      try {
        if (email !== '' && password !== '') {
          setError('')
          const response = await login(email, password)
          if (response === 'success') {
            // Check if user is a guest and redirect accordingly
            const userToken = JSON.parse(localStorage.getItem('userToken'))
            if (
              userToken &&
              (userToken.is_guest === 1 ||
                userToken.is_guest === true ||
                userToken.isGuest === 1 ||
                userToken.isGuest === true)
            ) {
              // Guest users go to report infringement page
              navigate('/report-infringement')
            } else {
              // Non-guest users follow normal redirect logic
              if (ifredirect !== '') {
                navigate(ifredirect)
              } else {
                navigate('/dashboard')
              }
            }
          } else {
            setError(response)
          }
        } else {
          setError('All fields are required')
          return
        }
      } catch (error) {
        setError('Login failed: ' + error)
      }
    }
  }

  return (
    <AuthLayout>
      <form
        onSubmit={handleSubmit}
        className='login-form'
      >
        <h3 className='heading'>Welcome</h3>
        <h6>Please login</h6>
        <div>
          <div className='form-group email'>
            <label htmlFor='email'>Email address</label>
            <div className='input-icon'>
              <img src='/images/icons/email.png' />
            </div>
            <input
              id='email'
              name='email'
              required
              type='email'
              className='form-control'
              placeholder='hello@protectartists.com'
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
          </div>
          <div className='form-group password'>
            <label htmlFor='password'>Password</label>
            <div className='relative'>
              <div className='input-icon'>
                <img src='/images/icons/password.png' />
              </div>  
              <input
                id='password'
                name='password'
                required
                type={showPassword ? 'text' : 'password'}
                className='form-control'
                placeholder='********'
                onChange={(e) => setPassword(e.target.value)}
                value={password}
              />
              <span
                className='password-toggle-icon'
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  top: '50%',
                  right: '12px',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                }}
              >
                {showPassword ? (
                  <Eye
                    size={20}
                    color='#888'
                  />
                ) : (
                  <EyeOff
                    size={20}
                    color='#888'
                  />
                )}
              </span>
            </div>
          </div>
          <p className='text-right mt-3 mb-2'>
            <Link
              className='font-90 font-weight-600 text-main'
              to='/forgot-password'
            >
              Forgot password?
            </Link>
          </p>
          {error !== '' ? (
            <div className='text-center text-red-500 font-semibold text-md mb-3'>{error}</div>
          ) : (
            <div className='py-4'></div>
          )}
          <button
            type='submit'
            name='submit'
            className='w-full btn btn-main-alt'
            disabled={isLoading}
          >
            {isLoading === false ? 'Login' : <Bounce animating={isLoading} />}
          </button>
        </div>
      </form>
    </AuthLayout>
  )
}

export default Home
